import { Link } from 'react-router-dom';
import { Clock, Star, ArrowRight, BadgeCheck, Lock } from 'lucide-react';
import { ArtistImage } from '../ArtistImage';

const GENRE_CONFIG = {
  'dancehall': { label: 'Dancehall', color: 'bg-lime/20 text-lime border-lime/30' },
  'reggae': { label: 'Reggae', color: 'bg-green-500/20 text-green-400 border-green-500/30' },
  'soca': { label: 'Soca', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' }
};

export function ArtistGridCard({ artist, index, canSeePrices, isArtist }) {
  return (
    <Link to={`/artist/${artist.id}`} className="artist-card block group" data-testid={`artist-card-${index}`}>
      <div className="aspect-[4/3] relative overflow-hidden">
        <ArtistImage
          src={artist.image_url}
          alt={artist.name}
          name={artist.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          {canSeePrices ? (
            <span className="price-tag">${artist.price.toFixed(2)}</span>
          ) : (
            <span className="price-tag flex items-center gap-1">
              <Lock className="w-3 h-3" />
              {isArtist ? 'Artist account' : 'Login to see price'}
            </span>
          )}
        </div>
      </div>
      <div className="p-6">
        <h3 className="font-heading text-xl font-bold mb-2 group-hover:text-lime transition-colors flex items-center gap-2">
          {artist.name}
          {artist.is_verified && <BadgeCheck className="w-5 h-5 text-blue-400" />}
        </h3>
        {artist.genres?.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-2">
            {artist.genres.slice(0, 2).map(genre => (
              <span key={genre} className={`text-xs px-2 py-0.5 rounded-full border ${GENRE_CONFIG[genre]?.color || 'bg-gray-500/20 text-gray-400 border-gray-500/30'}`}>
                {GENRE_CONFIG[genre]?.label || genre}
              </span>
            ))}
          </div>
        )}
        <p className="text-sm text-[#A1A1AA] mb-4 line-clamp-2">{artist.bio}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm text-[#666]">
            <Clock className="w-4 h-4" /><span>{artist.delivery_days} days delivery</span>
          </div>
          {canSeePrices && artist.average_rating && (
            <div className="flex items-center gap-1">
              <Star className="w-4 h-4 text-lime fill-lime" />
              <span className="text-sm text-lime">{artist.average_rating}</span>
            </div>
          )}
          <ArrowRight className="w-5 h-5 text-lime opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
      </div>
    </Link>
  );
}
